import { render } from "./TrainingDatabaseReport.vue?vue&type=template&id=1d8d2b2c&scoped=true"
import script from "./TrainingDatabaseReport.vue?vue&type=script&lang=js"
export * from "./TrainingDatabaseReport.vue?vue&type=script&lang=js"

import "./TrainingDatabaseReport.vue?vue&type=style&index=0&id=1d8d2b2c&scoped=true&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d8d2b2c"]])

export default __exports__